export const COOKIE_LOCALE_KEY = "NEXT_LOCALE";
export const COOKIE_THEME_KEY = "FLUX_THEME";
